import React, { Fragment } from 'react';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';

import GridItem from '../../../../../GridItem';

import { useCardContext } from '../../../../index';

import styles, { mainCls, mapCls } from './style';

const useStyles = createStyle(styles);

export default function Title({
  depthInfos,
  uri,
  title,
  goToPDP,
}) {
  const { maplist } = useCardContext();

  const cls = useStyles();

  const titleCls = makeClassName([
    cls[maplist ? mapCls : mainCls],
    'tp-s--l tp-w--l c-txt--f0',
    depthInfos.titleClamp,
  ]);

  const linkCLick = (e) => goToPDP({ e });
  const rightCLick = (e) => goToPDP({ e, rightClick: true });

  return (
    <GridItem behavior="fixed">
      <p className={titleCls}>
        <a
          href={uri}
          className={`${cls[`${mainCls}--a`]} c-txt--f0`}
          onClick={linkCLick}
          onContextMenu={rightCLick}
          title={title.main}
        >
          {title.main}
        </a>
      </p>
      {title.additional.length > 0 && (
        <p className="tp-s--m tp-w--s c-txt--f5">
          {title.additional.map((part, index) => {
            const sep = index > 0 && <span className={`${cls[`${mainCls}--bull`]} pr--xs pl--xs is-rel`}>&nbsp;</span>;
            return <Fragment key={`tit_${part}`}>{sep}{part}</Fragment>;
          })}
        </p>
      )}
    </GridItem>
  );
}